module.exports = __webpack_public_path__ + "img/pay-logo.137c77b9.png";